var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"inline-flex rounded items-center py-1.5 px-2.5 text-sm font-medium bg-tertiary-400 text-white"},[_vm._t("default",[_vm._v(" – ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }